import { __awaiter, __generator, __read } from "tslib";
import { useCallback, useState } from "react";
export var RequestStatus;
(function (RequestStatus) {
  RequestStatus["NOT_REQUESTED"] = "NOT_REQUESTED";
  RequestStatus["PENDING"] = "PENDING";
  RequestStatus["SUCCESS"] = "SUCCESS";
  RequestStatus["FAILED"] = "FAILED";
})(RequestStatus || (RequestStatus = {}));
export var useRequests = function (asyncFunction) {
  var _a = __read(useState(null), 2),
    data = _a[0],
    setData = _a[1];
  var _b = __read(useState(RequestStatus.NOT_REQUESTED), 2),
    status = _b[0],
    setStatus = _b[1];
  var _c = __read(useState(null), 2),
    error = _c[0],
    setError = _c[1];
  var sendRequest = useCallback(
    function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var data_1, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setStatus(RequestStatus.PENDING);
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3, , 4]);
              return [4 /*yield*/, asyncFunction()];
            case 2:
              data_1 = _a.sent();
              setData(data_1);
              setStatus(RequestStatus.SUCCESS);
              return [3 /*break*/, 4];
            case 3:
              error_1 = _a.sent();
              setError(error_1);
              setStatus(RequestStatus.FAILED);
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    },
    [setStatus, asyncFunction, setError, setData]
  );
  return {
    data: data,
    status: status,
    error: error,
    sendRequest: sendRequest,
  };
};
